module.exports = __webpack_public_path__ + "img/Cuba2.9e35b4b2.png";